import { ActionTypes, TagDefinitionActions } from './tag-definition.actions';
import { TagDefinitionState } from './tag-definition.model';

export const tagDefinitionState: TagDefinitionState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getTagDefinitionLoading: false,
  getTagDefinitionLoaded: false,
  tagDefinition: null,
  addTagDefinitionLoading: false,
  addTagDefinitionLoaded: false,
  editTagDefinitionLoading: false,
  editTagDefinitionLoaded: false,
  deleteTagDefinitionsLoading: false,
  deleteTagDefinitionsLoaded: false,
  siteDataLoading: false,
  siteDataLoaded: false,
  siteData: [],
  lineDataLoading: false,
  lineDataLoaded: false,
  lineData: null,
  stationsDataLoading: false,
  stationsDataLoaded: false,
  stationsData: [],
  destinationsDataLoading: false,
  destinationsDataLoaded: false,
  destinationsData: [],
  heartbeatSettingsDataLoading: false,
  heartbeatSettingsDataLoaded: false,
  heartbeatSettingsData: [],
  cleanerTagDefinitionsDataLoading: false,
  cleanerTagDefinitionsDataLoaded: false,
  cleanerTagDefinitionsData: [],
  destinationMapDataLoading: false,
  destinationMapDataLoaded: false,
  destinationMapData: {},
};

export function tagDefinitionReducer(
  state: TagDefinitionState = tagDefinitionState,
  action: TagDefinitionActions,
): TagDefinitionState {
  switch (action.type) {
    case ActionTypes.TAG_DEFINITIONS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.TAG_DEFINITIONS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_TAG_DEFINITION:
      return {
        ...state,
        getTagDefinitionLoading: true,
        getTagDefinitionLoaded: false,
      };
    case ActionTypes.GET_TAG_DEFINITION_COMPLETED:
      return {
        ...state,
        tagDefinition: action.payload.data,
        getTagDefinitionLoading: false,
        getTagDefinitionLoaded: true,
      };
    case ActionTypes.ADD_TAG_DEFINITION:
      return {
        ...state,
        addTagDefinitionLoading: true,
        addTagDefinitionLoaded: false,
      };
    case ActionTypes.ADD_TAG_DEFINITION_COMPLETED:
      return {
        ...state,
        addTagDefinitionLoading: false,
        addTagDefinitionLoaded: true,
      };
    case ActionTypes.EDIT_TAG_DEFINITION:
      return {
        ...state,
        editTagDefinitionLoading: true,
        editTagDefinitionLoaded: false,
      };
    case ActionTypes.EDIT_TAG_DEFINITION_COMPLETED:
      return {
        ...state,
        editTagDefinitionLoading: false,
        editTagDefinitionLoaded: true,
      };
    case ActionTypes.DELETE_TAG_DEFINITIONS:
      return {
        ...state,
        deleteTagDefinitionsLoading: true,
        deleteTagDefinitionsLoaded: false,
      };
    case ActionTypes.DELETE_TAG_DEFINITIONS_COMPLETED:
      return {
        ...state,
        deleteTagDefinitionsLoading: false,
        deleteTagDefinitionsLoaded: true,
      };
    case ActionTypes.SITES_DATA_LOADING:
      return {
        ...state,
        siteDataLoading: true,
        siteDataLoaded: false,
      };
    case ActionTypes.SITES_DATA_COMPLETED:
      return {
        ...state,
        siteData: action.payload,
        siteDataLoading: false,
        siteDataLoaded: true,
      };
    case ActionTypes.LINES_DATA_LOADING:
      return {
        ...state,
        lineDataLoading: true,
        lineDataLoaded: false,
      };
    case ActionTypes.LINES_DATA_COMPLETED:
      return {
        ...state,
        lineData: action.payload,
        lineDataLoading: false,
        lineDataLoaded: true,
      };
    case ActionTypes.STATIONS_DATA_LOADING:
      return {
        ...state,
        stationsDataLoading: true,
        stationsDataLoaded: false,
      };
    case ActionTypes.STATIONS_DATA_COMPLETED:
      return {
        ...state,
        stationsData: action.payload.data,
        stationsDataLoading: false,
        stationsDataLoaded: true,
      };
    case ActionTypes.DESTINATIONS_DATA_LOADING:
      return {
        ...state,
        destinationsDataLoading: true,
        destinationsDataLoaded: false,
      };
    case ActionTypes.DESTINATIONS_DATA_COMPLETED:
      return {
        ...state,
        destinationsData: action.payload,
        destinationsDataLoading: false,
        destinationsDataLoaded: true,
      };
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADING:
      return {
        ...state,
        heartbeatSettingsDataLoading: true,
        heartbeatSettingsDataLoaded: false,
      };
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_COMPLETED:
      return {
        ...state,
        heartbeatSettingsData: action.payload,
        heartbeatSettingsDataLoading: false,
        heartbeatSettingsDataLoaded: true,
      };
    case ActionTypes.CLEANER_TAG_DEFINITIONS_DATA_LOADING:
      return {
        ...state,
        cleanerTagDefinitionsDataLoading: true,
        cleanerTagDefinitionsDataLoaded: false,
      };
    case ActionTypes.CLEANER_TAG_DEFINITIONS_DATA_COMPLETED:
      return {
        ...state,
        cleanerTagDefinitionsData: action.payload,
        cleanerTagDefinitionsDataLoading: false,
        cleanerTagDefinitionsDataLoaded: true,
      };
    case ActionTypes.DESTINATION_MAP_DATA_LOADING:
      return {
        ...state,
        destinationMapDataLoading: true,
        destinationMapDataLoaded: false,
      };
    case ActionTypes.DESTINATION_MAP_DATA_COMPLETED:
      return {
        ...state,
        destinationMapData: action.payload,
        destinationMapDataLoading: false,
        destinationMapDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
